"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onInput: function ({params}) {
        GState.bind(this, [
            'tenant',
            'user',
            'screen'
        ]);
        const parent = window.location.pathname.split('/')[1];
        this.isPreview = parent.includes('preview');
        this.type = this.isPreview ? parent.split('-')[1] : parent;
        this.getDetails(params.id);
        this.hasEnrolled(params.id);
    },
    onEnrol: function (status) {
        this.setState('showEnroll', status);
    },
    getDetails: async function (id) {
        this.setState('details', null);
        try {
            const response = await Request(`/learner/${ this.type }/${ id }`);
            if (response.error)
                throw new Error(response.message);
            this.setState('details', response[this.type] || false);
        } catch (error) {
            console.log(`Error Fetching ${ this.type.toCapitalCase() }: `, error);
            this.setState('details', false);
        }
    },
    hasEnrolled: async function (id) {
        this.setState('enrolled', 'checking');
        try {
            const {error, message, reason, payment, enrollment, entity, enrollmentId} = await Request(`/enrollment/${ id }`);
            payment && payment.entity && payment.enrollmentId ? this.setState('requirePayment', payment) : this.setState('enrolled', reason ? message + ': ' + reason : enrollment);
        } catch (error) {
            console.log(`Error Checking ${ this.type.toCapitalCase() } Enroll: `, error);
            this.setState('enrolled', 'no');
        }
    },
    onMakePayment: async function (enrollmentId, callback) {
        try {
            await window.makePayment({
                entity: {
                    name: 'enrollment',
                    id: enrollmentId,
                    label: Locale('Enroll for a ') + this.type,
                    attach: true
                },
                amount: this.state.details.price.amount,
                currency: this.state.details.price.currency.id,
                items: [{
                        type: this.type,
                        name: this.state.details.name,
                        price: this.state.details.price.amount,
                        count: 1
                    }]
            });
            typeof callback == 'function' && callback();
            navigate(`/classroom/${ this.type }/${ this.input.params.id }`);
        } catch (error) {
            console.log('Failed making payment: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Availability_template = require("../../components/Availability/index.marko"),
    Availability_tag = marko_loadTag(Availability_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Schedules_template = require("../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    EnrolStatus_template = require("./components/EnrolStatus.marko"),
    EnrolStatus_tag = marko_loadTag(EnrolStatus_template),
    Button_template = require("../../../components/Button/index.marko"),
    Button_tag = marko_loadTag(Button_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Informations_template = require("./components/Informations.marko"),
    Informations_tag = marko_loadTag(Informations_template),
    Caption_template = require("./components/Caption.marko"),
    Caption_tag = marko_loadTag(Caption_template),
    Prerequisites_template = require("./components/Prerequisites.marko"),
    Prerequisites_tag = marko_loadTag(Prerequisites_template),
    Instructors_template = require("./components/Instructors.marko"),
    Instructors_tag = marko_loadTag(Instructors_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    EnrolModal_template = require("./components/EnrolModal.marko"),
    EnrolModal_tag = marko_loadTag(EnrolModal_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "content-header"
      },
    marko_attrs1 = {
        "class": "content-body"
      },
    marko_attrs2 = {
        "class": "theme-bg py-2"
      },
    marko_attrs3 = {
        "class": "col p-2 pl-4"
      },
    marko_attrs4 = {
        "class": "card-title"
      },
    marko_attrs5 = {
        "class": "blue-grey-text"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("beb68e"),
    marko_node0 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "card-text mt-2 pr-6 font-medium-1"
      },
    marko_node1 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "mt-4"
      },
    marko_attrs8 = {
        "class": "btn btn-secondary btn-lg btn-block"
      },
    marko_attrs9 = {
        "class": "col p-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        if (state.details === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (state.details === false) {
          EmptyList_tag({
              message: "The page you are trying to access is nowhere to be found",
              routeTo: (component.type + "s").toLowerCase()
            }, out, __component, "2");
        } else {
          const smallScreen = ['xs', 'sm'].includes( state.screen.media )

          out.be("section", {
              "class": marko_classValue(!smallScreen ? "pl-5" : false)
            }, "3", component, null, 1);

          out.be("div", marko_attrs0, "4", component);

          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    ns: "col-md-3 col-12",
                    qs: "col-md-4 col-12",
                    hs: "col-md-5 col-12",
                    class: "p-0",
                    renderBody: function(out) {
                      Image_tag({
                          alt: state.details.name,
                          src: state.details.poster,
                          class: "w-100 h-100"
                        }, out, __component, "7");
                    }
                  }, out, __component, "6");

                Row_tag({
                    class: "m-0 col",
                    renderBody: function(out) {
                      out.be("div", marko_attrs3, "9", component);

                      Availability_tag({
                          type: state.details.availability
                        }, out, __component, "10");

                      out.e("h4", marko_attrs4, "11", component, 1)
                        .t(state.details.name, component);

                      out.e("div", marko_attrs5, "12", component, 1)
                        .e("p", marko_attrs6, "13", component, 1)
                          .t(state.details.description, component);

                      if (((typeof state.enrolled) == "object") && state.enrolled.for.program) {
                        const { id, name } = state.enrolled.for.program

                        out.be("h5", null, "14", component);

                        Locale_tag({
                            text: "Program"
                          }, out, __component, "15");

                        out.t(": ");

                        route_link_tag({
                            href: "/program/" + id,
                            renderBody: function(out) {
                              out.t(name, component);
                            }
                          }, out, __component, "16");

                        out.ee();
                      }

                      Schedules_tag({
                          list: state.details.schedules
                        }, out, __component, "17");

                      out.n(marko_node0, component);

                      out.ee();

                      WSAdapt_tag({
                          ns: "col-xl-3 col-lg-4",
                          hs: "col-lg-12",
                          class: "p-2 pr-4",
                          renderBody: function(out) {
                            if (!component.isPreview) {
                              if (state.requirePayment && state.requirePayment.entity) {
                                out.be("button", marko_attrs8, "20", component, null, 0, {
                                    onclick: __component.d("click", "onMakePayment", false, [
                                        state.requirePayment.enrollmentId
                                      ])
                                  });

                                Locale_tag({
                                    text: "Pay Now",
                                    class: "text-uppercase"
                                  }, out, __component, "21");

                                out.ee();
                              } else {
                                EnrolStatus_tag({
                                    status: (typeof state.enrolled) == "string" ? state.enrolled : "yes",
                                    type: component.type,
                                    id: input.params.id
                                  }, out, __component, "22", [
                                  [
                                    "enrol",
                                    "onEnrol",
                                    false,
                                    [
                                        true
                                      ]
                                  ]
                                ]);
                              }

                              out.n(marko_node1, component);

                              out.be("div", marko_attrs7, "24", component);

                              Button_tag({
                                  icon: "bx-heart",
                                  activeIcon: "bx-heart",
                                  class: "mx-1 font-large-1",
                                  activeClass: "text-primary mx-1 font-large-1",
                                  title: "Like"
                                }, out, __component, "25");

                              Button_tag({
                                  icon: "bx-pin",
                                  activeIcon: "bxs-pin",
                                  class: "mx-1 font-large-1",
                                  activeClass: "text-primary mx-1 font-large-1",
                                  title: "Pin"
                                }, out, __component, "26");

                              Button_tag({
                                  icon: "bx-share-alt",
                                  activeIcon: "bxs-share-alt",
                                  class: "mx-1 font-large-1",
                                  activeClass: "text-primary mx-1 font-large-1",
                                  title: "Share"
                                }, out, __component, "27");

                              out.ee();
                            }
                          }
                        }, out, __component, "19");
                    }
                  }, out, __component, "8");
              }
            }, out, __component, "5");

          out.ee();

          out.be("div", marko_attrs1, "28", component);

          out.be("section", marko_attrs2, "29", component);

          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                out.be("div", marko_attrs9, "31", component);

                Informations_tag(marko_assign({
                    type: component.type
                  }, state.details), out, __component, "32");

                out.ee();

                WSAdapt_tag({
                    ns: "col-lg-4 col-12",
                    qs: "col-md-4 col-12",
                    hs: "col-12",
                    class: "px-md-3 px-0",
                    renderBody: function(out) {
                      Caption_tag(marko_assign({
                          tenant: state.tenant.name
                        }, state.details), out, __component, "34");

                      Prerequisites_tag({
                          list: state.details.prerequisites
                        }, out, __component, "35");
                    }
                  }, out, __component, "33");
              }
            }, out, __component, "30");

          out.ee();

          Instructors_tag({
              list: state.details.instructors
            }, out, __component, "36");

          out.ee();

          out.ee();

          if (state.showEnroll) {
            EnrolModal_tag(marko_assign({
                type: component.type
              }, state.details), out, __component, "37", [
              [
                "cancel",
                "onEnrol",
                false,
                [
                    false
                  ]
              ],
              [
                "make-payment",
                "onMakePayment",
                false
              ],
              [
                "done",
                () => navigate(`/classroom/${component.type}/${input.params.id}`),
                false
              ]
            ]);
          }
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
